import { Box } from '@mui/material';
import { useEmployeeAttendance } from '../../hooks/useEmployeeAttendance';
import { DialogUI } from '../Interface';
import { EmployeeAttendancePage } from './EmployeeAttendancePage';
import { EmployeeAttendanceMode } from '../../config/employeeAttendance';

const EmployeeAttendanceDialog = ({ onClose, dialogData }) => {
  const employeAttendanceState = useEmployeeAttendance();
  const { open } = dialogData;

  return (
    <DialogUI
      open={open}
      headerContent="Lejelentés"
      fullWidth={true}
      onClose={onClose}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '1000px',
            mx: 1,
            height: '90vh',
          },
        },
        '& .MuiDialogContent-root': {
          px: 1,
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <Box mt="1rem" minHeight={0}>
        <EmployeeAttendancePage
          mode={EmployeeAttendanceMode.DIALOG}
          employeAttendanceState={employeAttendanceState}
          dialog={{
            ...dialogData,
            handleClose: onClose,
          }}
        />
      </Box>
    </DialogUI>
  );
};

export default EmployeeAttendanceDialog;
